import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { KidsAppAvailableStore } from './kids-buchung-app-available.store';
import { KidsBuchungService } from './kids-buchung.service';
import { AuthStateFacade } from '../auth/auth-state.facade';

export const kidsBuchungResolver: ResolveFn<void> = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const buchungService = inject(KidsBuchungService);
  const authStateFacacde = inject(AuthStateFacade);

  const appAvailableStore = inject(KidsAppAvailableStore);
  await appAvailableStore.initialize();

  if (appAvailableStore.isAppAvailable()) {
    // Prüfung auf "Direkt Login" über login code param
    const token = route.queryParams['token'];

    if (token) {
      await buchungService.login(token);
    } else if (authStateFacacde.authenticated()) {
      await buchungService.ermittleKidsDaten();
    }
  }
};
